<template>
  <div class="modal-content">
    <div class="modal-header">
      <button @click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"
              style="height: 30px; border-radius: 30px; font-size: 30px;"><span
        aria-hidden="true">×</span></button>
      <h2 class="title lg-cond pt-10 pb-10">{{ $t('store.add_new_store') }}</h2>
    </div>

    <b-row style="padding-top: 15px;">
      <b-col :xl="10" style="padding-left: 5px; padding-right: 0">
        <b-input-group>
          <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="field" prefix="store">
          </select-dropdown>
          <input type="text" class="form-control" v-model="key" v-on:keydown.enter="getOutletList"/>
          <div class="input-group-append">
            <b-input-group-append>
              <b-btn @click="getOutletList()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
            </b-input-group-append>
          </div>
        </b-input-group>
      </b-col>
      <b-col xl="2">
        <div class="pull-right">
          <b-input-group v-bind:prepend="$t('store.status')">
            <b-form-select v-model="filter.status" v-bind:value="filter.status" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('store.active')">
            </b-form-select>
          </b-input-group>
        </div>
      </b-col>
    </b-row>

    <div class="table-responsive outlet-data">
      <table class="table table-striped table-hover table-sm header-pointer table-bordered">
        <thead>
        <tr>
          <th scope="col">
          <div class="custom-control custom-checkbox custom-control-inline">
            <input id="checkbox1" type="checkbox" class="custom-control-input" @change="selectAll" v-model="allSelected">
            <label for="checkbox1" class="custom-control-label"></label>
          </div>
        </th>
          <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)">
            <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
            <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
            <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
            <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="dataTable.items.length == 0">
          <td class="text-center" :colspan="dataTable.fields.length + 2">
            {{$t('message.no_data')}}
          </td>
        </tr>
        <tr v-for="item in dataTable.items" :key="item.id">
          <td scope="row">
            <div class="custom-control custom-checkbox custom-control-inline">
              <input :id="'checkbox_item_' + item.id" type="checkbox" class="custom-control-input" v-model="uuids" @change="updateAllSeleted" :value="item.uuid">
              <label :for="'checkbox_item_' + item.id" class="custom-control-label"></label>
            </div>
          </td>

          <td scope="row" v-for="field in dataTable.fields" :key="field.id">
            <span v-if="field.render != null" v-html="field.render(item[field.name == 'outlet_collection' ? 'quote_time' : field.name == 'outlet_delivery' ? 'quote_time' : field.name], item)"></span>
            <span v-if="field.render == null">
              {{item[field.name]}}
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <b-row>
      <b-col>
        <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
      </b-col>
      <b-col col lg="1">
        <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <button type="button" class="btn bg-main border-radius-4px pull-right pl-3 pr-3" :disabled="uuids.length <= 0" v-on:click="addStore()">{{$t('common.add')}}({{uuids.length}})</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import DataTable from '../../../components/Partials/DataTable'
  import axios from 'axios'

  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null
  export default {
    name: 'StoreForm',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      SelectDropdown,
      DataTable
    },
    data: function () {
      return {
        allSelected: false,
        uuids: [],
        field: null,
        key: null,
        type: 'like',
        statuses: [],
        filter: {
          options: [],
          selected: null,
          status: 1,
          code: '',
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'code',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'name',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
            {
              name: 'area_code',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'jpchar',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'owner_code',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'owner_name',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'address',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            }
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 10,
          source: null
        },
      }
    },
    methods: {
      updateSort: function (field) {
        for (let i in vm.dataTable.fields) {
          if (vm.dataTable.fields[i].name == field && (vm.dataTable.fields[i].sort == null || vm.dataTable.fields[i].sort == false)) {
            return
          }
        }
        if (vm.dataTable.sort.field != field) {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (vm.dataTable.sort.type == 'asc') {
            vm.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            vm.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }
        vm.getOutletList()
      },
      addStore () {
        let data = {}
        data['outlet_uuids'] = vm.uuids
        data['type'] = "add"
        vm.axios.outlet.addStoreIntoStoreGroup(vm.uuid, data, response => {
          vm.$session.start()
          vm.$session.set('outlet_uuids', response.data.data.item.outlet_ids)

          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.$emit('close')
        })
      },
      selectAll: function () {
        if (vm.allSelected == true) {
          for (let i in vm.dataTable.items) {
            if (vm.uuids.indexOf(vm.dataTable.items[i].uuid) === -1) {
              vm.uuids.push(vm.dataTable.items[i].uuid)
            }
          }
        } else {
          let uuids = []
          for (let j in vm.uuids) {
            let exist = false
            for (let i in vm.dataTable.items) {
              if (vm.dataTable.items[i].uuid == vm.uuids[j]) {
                exist = true
                break
              }
            }

            if (!exist) {
              uuids.push(vm.uuids[j])
            }
          }
          vm.uuids = vm._.cloneDeep(uuids)
        }
      },
      updateAllSeleted: function () {
        let total = 0
        for (let j in vm.uuids) {
          for (let i in vm.dataTable.items) {
            if (vm.dataTable.items[i].uuid == vm.uuids[j]) {
              total += 1
              break
            }
          }
        }

        if (vm.dataTable.items.length == total) {
          vm.allSelected = true
        } else {
          vm.allSelected = false
        }
      },
      getStatusData () {
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ""},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
        }
      },
      getOutletList () {
        if (cancel != null) {
          cancel()
        }
        let search = "";
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
            search = "&"+ this.field + "=" + this.key.trim()
        }
        if (this.filter.status != '') {
            search = search + "&active=" + this.filter.status;
        }
        
        let params = "?limit="+this.dataTable.perPage+"&page=" +this.dataTable.currentPage+"&sort_by="+this.dataTable.sort.field+"&order_by="+this.dataTable.sort.type+ search;

        vm.axios.outlet.getOutletList(params,{
            cancelToken: new CancelToken(function executor(c) {
              cancel = c
            })
          },  
          function(response){
            vm.dataTable.items = response.data.data.items
            vm.dataTable.total = response.data.data.pagination.total
            vm.updateAllSeleted()
          }
        )
      }
    },
    updated () {
      this.debouncedInput = _.debounce(this.getOutletList, 240)
    },
    created: function () {
      this.debouncedInput = _.debounce(this.getOutletList, 240)
      vm = this
      let CancelToken = vm.axios.CancelToken
      this.dataTable.source = CancelToken.source()

      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true) {
          this.filter.options.push(this.dataTable.fields[i])
        }
        if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
          this.dataTable.sort = {
            field: this.dataTable.fields[i].name,
            type: 'asc'
          }
        }
      }
      vm.getStatusData()
      vm.getOutletList()
    },
    watch: {
      key: function (val) {
        this.debouncedInput()
      },
      'dataTable.currentPage': function (val) {
        vm.getOutletList()
      },
      'dataTable.perPage': function (val) {
        vm.getOutletList()
      },
      'filter.status': function (val) {
        vm.getOutletList()
      }
    }
  }
</script>

<style scoped>
  .alert-danger2 {
    color: #a94442;
    font-weight: bold;
  }

  .free-menu-description{
    cursor: pointer;
  }

  .v--modal-box {
    height: auto !important;
    top: 50px !important;
  }
  .modal-coupon .v--modal {
    min-width: 0px !important;
  }

  .modal-header{
    display: inline-block;
  }

  .title{
    font-size: 20px;
  }

  .row,
  .outlet-data{
    padding-left: 15px;
    padding-right: 15px;
  }

  .modal-content{
    border: none;
    padding-bottom: 15px;
  }

  .modal-content .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }

  .modal-content .custom-control-label::before {
    border-radius: 3px !important;
  }

 .bg-main { 
    background: #0091ff;    
    color: #fff !important; 
  }   

  .dg-btn--cancel{  
    background-color: #0091ff !important; 
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/store_group/StoreGroup.vue